import { dateFormats, toUtc } from "@payping/utils/dateUtils";

// TODO: this function and its uses should be removed,
//  it has only been added temporarily to convert problematic date values
//  (/report/AdvancedTransactionReport & /report/WithdrawTransactions & /report/DashboardSummery)
export function getCorrectDate(str?: string): string | undefined {
  let date = str?.split("T")[0];
  const year = date?.match(/[\d]*/)?.[0];
  if (year && Number(year) < 1500)
    date = toUtc({
      convertTime: false,
      date,
      dateFormat: date?.includes("-") ? dateFormats.ui.jalaliDate : dateFormats.standard.jalaliDate,
      toFormat: dateFormats.standard.utcDate,
    }).string;
  const time = str?.split("T")[1]?.split(".")[0] || "";
  const milliseconds = str?.split("T")[1]?.split(".")[1] || "000000";
  const timezone = (!time?.includes("Z") && time?.split("+")[1]) || "00:00";
  const result = `${date}T${time}.${milliseconds}+${timezone}`;
  return result;
}
